import { type ApolloClient, gql } from '@apollo/client/core';
import { Mutation } from '../../../generated/api.graphql';
import { VPResult } from '../../VPResult';
import * as VPErrors from '../../../VPError';

export const CONNECT_PRISM_EVENT_MUTATION = gql`
  mutation ConnectPrismEvent($eventId: Int!, $prismEventId: Int!) {
    connectPrismEvent(input: {eventId: $eventId, prismEventId: $prismEventId}) {
      success
      errors { path message }
      event { id connectedToPrism prismEventId }
    }
  }
`;

export const DISCONNECT_PRISM_EVENT_MUTATION = gql`
  mutation DisconnectPrismEvent($eventId: Int!) {
    disconnectPrismEvent(input: {eventId: $eventId}) {
      success
      errors { path message }
      event { id connectedToPrism prismEventId }
    }
  }
`;

export const SYNC_PRISM_SALES_MUTATION = gql`
  mutation SyncPrismSales($eventId: Int!) {
    syncPrismSales(input: {eventId: $eventId}) {
      success
      errors { path message }
    }
  }
`;

type PrismMutationResult = VPResult<null>;

export const connectPrismEvent = async (
  client: ApolloClient<Mutation>,
  eventId: number,
  prismEventId: number,
): Promise<PrismMutationResult> => {
  const { data } = await client.mutate({
    mutation: CONNECT_PRISM_EVENT_MUTATION,
    variables: { eventId, prismEventId },
  });
  const result = data?.connectPrismEvent;
  return {
    success: result?.success ?? false,
    errors: VPErrors.fromGqlCollection(result?.errors),
  };
};

export const disconnectPrismEvent = async (
  client: ApolloClient<Mutation>,
  eventId: number,
): Promise<PrismMutationResult> => {
  const { data } = await client.mutate({
    mutation: DISCONNECT_PRISM_EVENT_MUTATION,
    variables: { eventId },
  });
  const result = data?.disconnectPrismEvent;
  return {
    success: result?.success ?? false,
    errors: VPErrors.fromGqlCollection(result?.errors),
  };
};

export const syncPrismSales = async (
  client: ApolloClient<Mutation>,
  eventId: number,
): Promise<PrismMutationResult> => {
  const { data } = await client.mutate({
    mutation: SYNC_PRISM_SALES_MUTATION,
    variables: { eventId },
  });
  const result = data?.syncPrismSales;
  return {
    success: result?.success ?? false,
    errors: VPErrors.fromGqlCollection(result?.errors),
  };
};
